import { UseClientApi } from '../utils/client-api';

function ok(response: any) {
  if (!response.Success) {
    return { isOk: false, message: response.Message };
  }
  return { isOk: true, data: response.Data };
}

export async function getPreservicios(filtros?: {
  fechaInicio?: string;
  fechaFin?: string;
  estado?: number | string;
  clienteODocumento?: string;
}) {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi('preservicios', 'GET', filtros));
  } catch {
    return { isOk: false, message: 'Error al obtener los preservicios' };
  }
}

export async function getPreservicioById(id: number) {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi(`preservicios/${id}`, 'GET'));
  } catch {
    return { isOk: false, message: 'Error al obtener el preservicio' };
  }
}

export async function createPreservicio(data: any) {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi('preservicios', 'POST', null, data));
  } catch {
    return { isOk: false, message: 'Error al crear el preservicio' };
  }
}

export async function updatePreservicio(id: number, data: any) {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi(`preservicios/${id}`, 'PUT', null, data));
  } catch {
    return { isOk: false, message: 'Error al actualizar el preservicio' };
  }
}

export async function convertirPreservicio(id: number, data: any) {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi(`preservicios/${id}/convertir`, 'POST', null, data));
  } catch {
    return { isOk: false, message: 'Error al convertir el preservicio' };
  }
}

export async function getNotasPreservicio(id: number) {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi(`preservicios/${id}/notas`, 'GET'));
  } catch {
    return { isOk: false, message: 'Error al obtener las notas' };
  }
}

export async function addNotaPreservicio(id: number, texto: string) {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi(`preservicios/${id}/notas`, 'POST', null, { PsrvN_Texto: texto }));
  } catch {
    return { isOk: false, message: 'Error al agregar la nota' };
  }
}

export async function addDetallePreservicio(preservicioId: number, prId: number, cantidad: number) {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi(`preservicios/${preservicioId}/detalle`, 'POST', null, { PsrvD_Pr_Id: prId, PsrvD_Cantidad: cantidad }));
  } catch {
    return { isOk: false, message: 'Error al agregar el producto' };
  }
}

export async function updateDetallePreservicio(detalleId: number, cantidad: number) {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi(`preservicios/detalle/${detalleId}`, 'PUT', null, { PsrvD_Cantidad: cantidad }));
  } catch {
    return { isOk: false, message: 'Error al actualizar el producto' };
  }
}

export async function deleteDetallePreservicio(detalleId: number) {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi(`preservicios/detalle/${detalleId}`, 'DELETE'));
  } catch {
    return { isOk: false, message: 'Error al eliminar el producto' };
  }
}

export async function getProductosParaPreservicio() {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi('preservicios/productos', 'GET'));
  } catch {
    return { isOk: false, message: 'Error al obtener los productos' };
  }
}

export async function getMiCliente() {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi('preservicios/mi-cliente', 'GET'));
  } catch {
    return { isOk: false, message: 'Error al obtener los datos del cliente' };
  }
}

export async function updateMiTelefono(telefono: string) {
  try {
    const { runApi } = UseClientApi();
    return ok(await runApi('preservicios/mi-telefono', 'PUT', null, { Cl_Telefono: telefono }));
  } catch {
    return { isOk: false, message: 'Error al actualizar el teléfono' };
  }
}
